<form class="sam-form-row settings-container">
   <div class="sam-form-row">
      <div class="sam-form-flex-row">
         <div class="sam-form-flex-row config-list-container sam-no-margin">
            <div class="sam-flex-auto">
               <samweb-searchbar
                  [searchValue$]="filterDisplayValue$"
                  (searchValueChangedDebounced)="searchTextChanged($event)"
               ></samweb-searchbar>
            </div>
            <div *samwebVar="isIciDisplayGrouped$ | async; let isGrouped">
               <div class="sam-clickable sam-center sam-margin-left sam-margin-right">
                  <div class="sam-full-height sam-no-margin sam-no-padding" (click)="setIciDisplayIsGrouped(isGrouped)">
                     <fa-icon
                        [icon]="isGrouped ? isIciDisplayGroupedActiveIcon : isIciDisplayGroupedNonActiveIcon"
                        size="lg"
                     ></fa-icon>
                  </div>
               </div>
            </div>
         </div>

         <div class="sam-form-row setting-tab-height wave-list-container sam-no-margin">
            <div class="sam-margin-left sam-center">
               <label>
                  {{ 'common.settings.agent_greetings.file_list_title' | translate }}
               </label>
            </div>
         </div>
      </div>

      <div class="sam-form-flex-row">
         <div class="sam-form-row config-list-container sam-no-margin">
            <div class="sam-full-height">
               <samweb-agent-greeting-configuration-list
                  class="sam-full-width sam-no-margin"
                  [searchValues]="separatedFilterValues$ | async"
                  [disabled]="!(wasValuePersisted$ | async)"
                  [draggedItemKey]="draggedItemKey$ | async"
                  [availableIci]="availableIci$ | async"
                  [skillList]="skillList$ | async"
                  (waveFileDropped)="dropAssigned($event)"
                  (removeAssignment)="removeAssignment($event)"
                  (expandGroup)="expandIciGroup($event)"
               ></samweb-agent-greeting-configuration-list>
            </div>
         </div>

         <div class="sam-form-row setting-tab-height wave-list-container sam-no-margin">
            <div class="sam-auto-overflow wave-list-height">
               <samweb-agent-greeting-wave-list
                  class="sam-full-width sam-full-height"
                  [agentGreetings]="agentGreetingWaves$ | async"
                  [availableDropZones]="availableDropZones$ | async"
                  [disabled]="!(wasValuePersisted$ | async)"
                  (waveDrop)="waveDrop($event)"
                  (removeWaveFile)="removeWaveFile($event)"
                  (dragStarted)="dragStarted($event)"
                  (dragEnded)="dragEnded($event)"
               >
               </samweb-agent-greeting-wave-list>
            </div>
            <div class="sam-flex-auto sam-margin-left-large">
               <samweb-greeting-upload-bar-dialog (uploadGreeting)="uploadGreeting($event)">
               </samweb-greeting-upload-bar-dialog>
            </div>
         </div>
      </div>
   </div>
</form>
